{
  "adminTime": {
    "showUtc": "Show UTC time",
    "showLocal": "Show local time"
  },
  "brand": "SHEN NONG SHI",
  "product": "Assessment workspace",
  "title": "SHEN NONG SHI",
  "pageTitle": "{{page}} · SHEN NONG SHI",
  "language": "Language",
  "lang": {
    "en": "English",
    "zh-TW": "繁體中文"
  },
  "theme": {
    "label": "Theme",
    "system": "System",
    "light": "Light",
    "dark": "Dark"
  },
  "footer": {
    "hrThread": "Questions? Contact HR through the email thread you already have.",
    "utc": "UTC"
  },
  "actions": {
    "continue": "Continue",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "close": "Close",
    "copy": "Copy",
    "copied": "Copied",
    "reveal": "Reveal",
    "hide": "Hide",
    "retry": "Try again",
    "back": "Back",
    "save": "Save",
    "delete": "Delete",
    "openInNewTab": "Opens in a new tab",
    "skipToContent": "Skip to content"
  },
  "time": {
    "hours": "{{count}} h",
    "minutes": "{{count}} min",
    "daysHoursLeft": "{{days}}d {{hours}}h left",
    "hoursMinutesLeft": "{{hours}}h {{minutes}}m left",
    "left": "left",
    "localAndUtc": "{{local}} ({{utc}})",
    "about": "about {{min}}–{{max}} min"
  },
  "state": {
    "provisioning": "Creating",
    "warming": "Warming up",
    "ready": "Ready to launch",
    "starting": "Starting GPU",
    "booting": "Starting workspace",
    "running": "Running",
    "stopping": "Pausing",
    "paused": "Paused",
    "error": "Error",
    "ended": "Closed",
    "deleted": "Deleted"
  },
  "errors": {
    "generic": "Something went wrong. We've been notified.",
    "network": "Network error. Check your connection and try again.",
    "rate_limited": "Too many attempts. Wait a moment and try again.",
    "unauthorized": "Your session has ended. Open your invite link again.",
    "forbidden": "You don't have access to this.",
    "action_in_progress": "Another action is still in progress. Wait a moment.",
    "invalid_state": "That action is not available right now.",
    "not_found": "Not found."
  },
  "a11y": {
    "loading": "Loading",
    "statusUpdated": "Status updated: {{state}}",
    "menu": "Menu"
  },
  "workspace": {
    "manualOperatorHint": "For this existing workspace, use the protected operator installer, then verify and activate secure access.",
    "notConfigured": "Secure workspace configuration is incomplete. An administrator must configure the gateway and Cloudflare credentials before setup can continue.",
    "setupDisabled": "Secure workspace setup is disabled. Enable automatic secure access in Settings before retrying.",
    "existingOperatorHint": "This existing workspace has not been converted. An administrator can opt it in and complete the protected installation workflow.",
    "opening": "Opening workspace…",
    "popupBlocked": "Allow pop-ups for the assessment portal, then try again.",
    "openFailed": "The workspace could not be opened. Try again. If the problem continues, contact your administrator.",
    "status": "Workspace access: {{status}}",
    "unavailable": "Workspace access needs attention. Contact HR or your administrator.",
    "vscode": "Open VS Code",
    "viewer": "Open Viewer",
    "tools": {
      "vscode": "VS Code",
      "viewer": "Viewer",
      "opencode": "OpenCode"
    },
    "copyUrl": "Copy {{tool}} URL",
    "linkHint": "These URLs stay the same. Sign in through the assessment portal to open them without a password.",
    "pausedHint": "Apps are unavailable while the workspace is not running. Check its status in the assessment portal and resume if available.",
    "removedHint": "Secure workspace access has been removed. Contact your administrator if you need access again.",
    "removingHint": "Secure workspace access is being removed. Existing sessions are closed.",
    "preparing": "Secure access is being prepared. Open buttons become available when preparation finishes and the workspace is running.",
    "manage": "Secure workspace access",
    "provision": "Set up this existing workspace",
    "retryProvision": "Retry setup",
    "activate": "Verify and activate",
    "cleanup": "Remove secure access",
    "cleanupConfirm": "This closes workspace sessions and removes its HTTPS addresses and tunnel. The old hostname will not be reused.",
    "operatorHint": "Secure access is prepared automatically for new workspaces. Open buttons become available when setup and workspace startup finish.",
    "operationFailed": "Setup could not complete. Check the workspace status and retry, or contact the administrator responsible for workspace configuration.",
    "states": {
      "pending": "Pending",
      "tunnel": "Creating tunnel",
      "origin-protected": "Origin protected",
      "connector": "Installing secure access",
      "verified": "Verifying HTTPS",
      "active": "Ready",
      "deleting": "Removing access",
      "deleted": "Access removed",
      "error": "Needs attention"
    },
    "startingApps": "Starting applications",
    "startingAppsHint": "The secure links are configured, but the applications are still starting. Both buttons become available when the machine is ready.",
    "stoppingApps": "Stopping",
    "stoppingAppsHint": "The machine is stopping. Wait until it is paused before resuming.",
    "closedApps": "Closed",
    "closedAppsHint": "This workspace is closed. Its applications cannot be opened.",
    "failedApps": "Unavailable",
    "failedAppsHint": "The machine needs attention. Resolve the startup error or retry before opening its applications.",
    "pausedApps": "Paused",
    "pausedAppsHint": "Apps are unavailable while the workspace is not running. Check its status in the assessment portal and resume if available.",
    "notLaunchedApps": "Not launched",
    "notLaunchedAppsHint": "Launch the assignment when you are ready. Applications become available after startup completes.",
    "preparingApps": "Preparing",
    "preparingAppsHint": "The assessment machine is being prepared. Applications are not available yet.",
    "unavailableApps": "Unavailable",
    "unavailableAppsHint": "The applications cannot be opened in the current workspace state.",
    "signInRequired": "Your sign-in has expired. Sign in again, then reopen the workspace.",
    "consentRequired": "Please review and accept the current privacy agreement in the portal before opening the workspace.",
    "rateLimited": "Too many workspace launch attempts. Wait one minute, then try again.",
    "accessDenied": "Workspace access was denied. Refresh the portal to check your session and machine status, then try again.",
    "gatewayUnavailable": "Secure workspace access is not ready. Wait for setup to finish, then try again.",
    "vscodeNotReady": "VS Code is not responding yet. Wait a moment, then try opening it again.",
    "viewerNotReady": "The viewer is not ready yet. Wait a moment, then try opening it again. You can still try VS Code.",
    "opencode": "Open OpenCode",
    "opencodeNotReady": "OpenCode is not ready yet. Wait a moment, then try again. VS Code remains available."
  },
  "guide": {
    "title": "Design guide",
    "eyebrow": "SHEN NONG SHI / Product design",
    "intro": "A focused place to do good work. Clear type, quiet surfaces, and just enough color to show what matters.",
    "source": "Company identity manual ↗",
    "scope": "The company manual governs identity, color and fonts. The layout and interaction rules below are the platform’s product application.",
    "identity": "Identity",
    "identityBody": "Use the original company artwork and preserve its proportions and clear space. Show it once in the header; use SHEN NONG SHI as the site identity.",
    "identityRule": "Use the supplied white artwork on dark backgrounds. Never tint, stretch, fade, or rebuild the logo with a font. Minimum sizes and clear space are specific to each lockup; see manual §1.3–1.3.5.",
    "lockup": "Product header",
    "mark": "Company mark",
    "color": "Color & contrast",
    "colorBody": "Silver, black and white carry the interface. Blue identifies the next action or a link. Red communicates danger. Amber is a product warning color.",
    "silver": "Brand silver",
    "silver2": "Secondary silver",
    "blue": "Action blue",
    "red": "Danger red",
    "tokens": "Theme-aware surfaces",
    "colorRule": "Brand swatches stay fixed in both themes. Semantic tokens adapt for legibility. Silver is decorative, never body text on white. Normal status stays neutral and always has a text label.",
    "type": "Typography",
    "typeBody": "Roboto for English. Noto Sans TC for Traditional Chinese. One clear page title, useful section headings, and readable supporting text.",
    "typeTitle": "Your workspace",
    "typeSection": "Ready when you are",
    "typeBodySample": "Open your workspace to continue the assessment. Pause the machine when you step away.",
    "typeCaption": "GPU time counts only while Isaac Sim is ready.",
    "typeRule": "Page title 28 / 36 px · section 20–24 px · body 14–16 px · supporting text 12 px. Use tabular numerals for time and costs. Reserve monospace for credentials and code.",
    "layout": "Layout & spacing",
    "layoutBody": "Group related content with alignment and space. Use a rule between sections; use a bordered panel only when its contents need a distinct boundary.",
    "layoutRule": "4 px spacing base · 16–24 px within groups · 40–48 px between sections · 4 px control radius. At narrow widths, stack columns and keep actions easy to reach. Shadows belong to overlays.",
    "actions": "Actions & forms",
    "actionsBody": "Use equal blue buttons for VS Code and Viewer: both tools support the assessment. Pause is the primary machine control. Keep destructive actions separate and explicit.",
    "primary": "Open VS Code",
    "secondary": "Open Viewer",
    "dangerAction": "Finish session",
    "email": "Sign-in email",
    "emailHelp": "Your sign-in code is sent to this address.",
    "errorLabel": "Assignment title",
    "error": "Enter a title for the assignment.",
    "disabled": "Unavailable",
    "loading": "Opening workspace",
    "states": "Status & feedback",
    "statesBody": "Show what happened and what to do next. Labels carry meaning even without color. Animate only while an operation is in progress.",
    "info": "Your machine is ready. Open VS Code to continue.",
    "warning": "Less than 1 hour of GPU time remains. Save your work before time runs out.",
    "danger": "Your time is over. The machine shuts down in 09:41. Save a copy of your work now.",
    "dialogTitle": "Finish your session?",
    "dialogBody": "You will not be able to resume this session. Save a copy of your work before finishing.",
    "dialogTrigger": "Preview confirmation",
    "toastTrigger": "Preview notification",
    "toastTitle": "Notification preview",
    "toastBody": "Your changes have been saved.",
    "accessibility": "Keep visible keyboard focus, labeled controls, linked error messages and reduced-motion support. Check both themes and both languages.",
    "examples": "Open screen examples",
    "candidatePreview": "Candidate workspace ↗",
    "adminPreview": "Admin dashboard ↗",
    "pause": "Pause machine",
    "workspace": "Workspace lifecycle",
    "workspaceBody": "Show the Access section only when Isaac Sim is ready and the candidate can use it. Hide the whole section when it is unavailable. Open a state below to inspect the actual screen.",
    "workspaceTiming": "GPU allowance counts only while Isaac Sim is ready. The assignment deadline continues after first launch, including startup and pauses.",
    "workspaceAdmin": "Admins retain connection details for troubleshooting. A configured secure URL alone does not mean the applications are ready.",
    "lifecycle": {
      "preparation": {
        "title": "Initial preparation",
        "body": "Preparation is automatic. No Pause, Finish, or Access section before the candidate launches."
      },
      "startup": {
        "title": "Starting / booting",
        "body": "After launch, Pause cancels startup and keeps files. Finish ends the assignment permanently. Access stays hidden."
      },
      "running": {
        "title": "Ready to work",
        "body": "Show Access with equal blue VS Code and Viewer buttons. Pause is the primary machine control; Finish is separate."
      },
      "paused": {
        "title": "Paused / stopping",
        "body": "Hide Access. While stopping, wait for confirmation. Once paused, offer Resume and Finish."
      },
      "grace": {
        "title": "Saving grace",
        "body": "Show the shutdown countdown and Finish only. Keep Access while applications are usable and access has not expired."
      },
      "ended": {
        "title": "Finished / expired",
        "body": "Hide Access and machine controls. Keep the completion message, usage information, and activity history."
      }
    },
    "markdownTitle": "Inline Markdown editor",
    "markdownHelp": "Write and format in place; switch to source for exact Markdown. The same editor is used for questions, answers and AI messages.",
    "markdownSample": "## A clear approach\n\nStart with the guarantee, then explain the **tradeoffs**.\n\n- Keep work recoverable\n- Make progress visible"
  },
  "assignmentKind": {
    "isaac_sim": "Isaac Sim",
    "gpu_vscode": "GPU + VS Code",
    "free_response": "Written answer"
  },
  "markdownEditor": {
    "hint": "Write naturally. Markdown shortcuts format as you type.",
    "sourceRequired": "This document contains HTML or images. Edit the original Markdown source to preserve it.",
    "source": "Markdown source",
    "formatted": "Formatted editor",
    "loading": "Loading editor…",
    "formatting": "Text formatting",
    "bold": "Bold",
    "italic": "Italic",
    "heading": "Heading",
    "bullet": "Bullet list",
    "ordered": "Numbered list",
    "quote": "Quote",
    "code": "Code block",
    "undo": "Undo",
    "redo": "Redo",
    "unavailable": "The formatted editor could not load. Your text is preserved; continue in Markdown source.",
    "tooLong": "This field exceeds {{limit}} characters. Shorten it before submitting; your text has been kept.",
    "task": "Task: {{text}}"
  }
}
